import React, { FC, useContext } from "react";
import { resolveWrappedDetailTabComponent } from "../../../utils";
import { DetailView } from "@data-root/types";
import { Tabs } from "../../tabs";
import { InlineContext, InlineSingleRowProps } from "@data-root/react";

export const Detail: FC<InlineSingleRowProps> = ({ loaded }) => {
  const { table, view } = useContext(InlineContext)!;

  return (
    <Tabs
      table={table}
      view={view as DetailView}
      resolver={resolveWrappedDetailTabComponent}
    />
  );
};
